import { __ONLY_WRITE_STATE_FROM_ACTIONS as writeState } from "@/__main__/app-state.mjs";
import { isPersistent, MAX_TIME } from "@/__main__/constants.mjs";
import { readData } from "@/__main__/get-data.mjs";

export async function loadBaseInfo(baseInfo) {
  const obj = await readData(["appMeta", "eventBaseInfo"]);
  return Object.assign(baseInfo, obj);
}

export function saveBaseInfo(baseInfo) {
  baseInfo[isPersistent] = MAX_TIME;
  writeState.appMeta.eventBaseInfo = baseInfo;
}

export async function loadUTMInfo(meta) {
  const obj = await readData(["appMeta", "utmInfo"]);
  return Object.assign(meta, obj);
}

export function saveUTMInfo(meta) {
  meta[isPersistent] = MAX_TIME;
  writeState.appMeta.utmInfo = meta;
}

export function loadBrowserInfo() {
  return readData(["appMeta", "browserInfo"]);
}

export function saveBrowserInfo(payload) {
  payload[isPersistent] = MAX_TIME;
  writeState.appMeta.browserInfo = payload;
}
